<span
  #input
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  (contextmenu)="onContextMenu($event)"
  (press)="onContextMenu($any($event))">
  <iu-prime-calendar
    #calendar
    [columnName]="data?.columnName"
    [hourFormat]="hourFormat"
    [isFieldOnly]="data?.isFieldOnly"
    [isLabelDisplay]="this.isLabelDisplay"
    [iupicsLocale]="locale"
    [label]="label"
    [readonlyInput]="isReadOnly"
    [showIcon]="true"
    [showTime]="true"
    [timeOnly]="true"
    (fieldChange)="fieldChange($event)" />

  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>
